// extracted by mini-css-extract-plugin
export default {"input":"_6T6FBh3IsVnA56NeAbwYX4"};